import { defineComponent as _defineComponent } from 'vue'
import { computed } from '../../../../../adapter-vue';
import TUIChatEngine from '@tencentcloud/chat-uikit-engine';
import Avatar from '../../../../common/Avatar/index.vue';
import { calculateTimestamp } from '../../../utils/utils';

interface IProps {
  sender: string;
  avatar: string;
  type: string;
  time: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-container',
  props: {
    sender: { default: '' },
    avatar: { default: '' },
    type: null,
    time: null
  },
  setup(__props: any) {

const props = __props as { sender: string, avatar: string, type: string, time: number }



const TYPES = TUIChatEngine.TYPES;

const isNoPadding = computed(() => {
  return [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO, TYPES.MSG_MERGER].includes(props.type);
});

return { __sfc: true,props, TYPES, isNoPadding, Avatar, calculateTimestamp }
}

})